<template>
  <div id="municipalInfo" data-role="page">
    <!-- content -->
    <div class="municipalInfo-content" data-position="fixed">
      <!-- 未連接至網路的提醒 -->
      <div v-if="!closeOffline && isOffline" class="v3offline">
        <i class="icon-exclamation-mark-circle"></i>
        <p>未連接至網路</p>
        <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
      </div>
      <!-- swiperTop 分類 -->
      <div id="infoTop" class="swiper-container swiperTop">
        <swiper :options="swiperTop" ref="infoTop">
          <swiper-slide
            class="swiper-slide"
            v-for="(typeVal, typeIdx) in infoType"
            :key="typeIdx"
            :typeId="typeVal.typeId"
            >{{ typeVal.typeName }}</swiper-slide
          >
        </swiper>
      </div>
      <div id="infoPages" class="swiper-container swiperPages">
        <swiper :options="swiperPages" class="swiper-wrapper" ref="infoPages">
          <swiper-slide
            class="swiper-slide"
            v-for="(typeVal, typeIdx) in infoType"
            :key="typeIdx"
            :typeId="typeVal.typeId"
            :selected="typeVal.typeId === typeIdx + 1"
          >
            <mescroll-vue
              ref="mescroll"
              :down="getMescrollDown(typeIdx)"
              :up="getMescrollUp(typeIdx)"
              @init="mescrollInit(typeIdx, arguments)"
            >
              <div class="detailWrap">
                <div class="articleList">
                  <ul v-if="typeVal.typeList && typeVal.typeList.length">
                    <template v-for="(infoVal, infoIdx) in typeVal.typeList">
                      <li v-if="infoVal.CreateAt || infoVal.StartAt.indexOf('T') !== -1 && new Date(infoVal.StartAt.split('.')[0].replace('T', ' ')) < new Date()" :key="infoIdx">
                        <div @click="seeDetail(typeVal.typeId, infoVal.Id, infoIdx)">
                          <div class="txt-info">
                            <span class="article_desc">{{ infoVal.Title }}</span>
                            <span class="article_date">
                              <template v-if="infoVal.StartAt">
                                  {{ filterDate(infoVal.StartAt, typeVal.typeId) }}
                              </template>
                              <template v-if="infoVal.CreateAt">
                                  {{ filterDate(infoVal.CreateAt, typeVal.typeId) }}
                              </template>
                            </span>                       
                            <span class="cgy-tag">
                              {{ infoVal.ActivitiesClass ? infoVal.ActivitiesClass : infoVal.NewsClass }}
                            </span>
                            <i class="icon-chevron-right"></i>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                  <div v-else-if="!typeVal.typeList" class="empty">
                    <!-- 初始空狀態 -->
                  </div>
                  <div v-else-if="!typeVal.typeList.length && !typeVal.mescroll.isDownScrolling" class="empty">
                    <div class="txt-box">
                      <i class="icon-system_empty"></i>
                      <h4>噢不！<br />{{ typeVal.typeName }}尚未有任何訊息</h4>
                    </div>
                  </div>
                </div>
              </div>
            </mescroll-vue>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div v-show="v3Toast.show" class="v3Toast">{{ v3Toast.text }}</div>
  </div>
</template>

<script lang="js">
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  data () {
    return {
      scrollTop: 0,
      swiperTop: {
        slidesPerView: '3',
        aginationClickable: true,//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
        spaceBetween: 0,//slide之间的距离（单位px）。
        freeMode: true,//默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
        loop: false,//是否可循环
        resistanceRatio: 0, //第一頁與最後一頁不可往前或往後滑動
        edgeSwipeDetection: true //開啟滑動邊緣返回上一頁
      },
      swiperPages:{
        direction: 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
        loop: false,
        preloadImages: false,
        lazy: true,
        autoHeight: false, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
        resistanceRatio: 0, //第一頁與最後一頁不可往前或往後滑動
        edgeSwipeDetection: true //開啟滑動邊緣返回上一頁
      },
      infoType: [
        {typeId: 1, typeName: "市府新聞", typeList: null},
        {typeId: 2, typeName: "近期活動", typeList: null},
        {typeId: 3, typeName: "焦點新聞", typeList: null},
      ],
      Authority: false,
      closeOffline:false,
      v3Toast:{
        show: false,
        text: '',
        duration: 1000
      },
      whichTypeIndexIsChoose: 0,
    }
  },
  components: {
    MescrollVue
  },
  watch: {
    isOffline: function(val) {
      // 在下次無網路時再度打開上面的 top tip
      if (!val) this.closeOffline = false
    }
  },
  mounted(){    
    console.log(process.env);
    this.CheckAuthority()
    this.InitSwiperList()
    this.getList(0)
    this.getList(1)
    this.getList(2)
  },
  activated() {
    // 如果曾滚动过,则还原位置
    if (this.scrollTop) {
      this.infoType[this.whichTypeIndexIsChoose].mescroll.scrollTo(this.scrollTop, 0)
    }
  },
  methods:{
    //取得新訊列表
    async getList(typeIndex, page = 0){
      const vobj = this
      let url = ''
      let resListName = ''
      switch(typeIndex) {
        case 0:
          url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/CityNews`
          resListName = 'CityNews'
          break
        case 1:
          url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/RecentActivities`
          resListName = 'CurrentActivities'
          break
        case 2:
          url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/HotNews`
          resListName = 'HotNews'
          break
      }
      const params = {
        Page: page,
        Size: 50,
      }
      await this.axios.get(url, {params}).then((response) => {
        console.log(response);
        // 檢查回傳資料是否為空
        if (!response.data) {
          this.infoType[typeIndex].typeList = []
          this.infoType[typeIndex].mescroll.endSuccess(50, false)
          this.infoType[typeIndex].mescroll.endUpScroll(false)
        } else {
          // 檢查列表是否為空
          if (!this.infoType[typeIndex].typeList || !this.infoType[typeIndex].typeList.length) {
            this.infoType[typeIndex].typeList = response.data.Data[resListName]
          } else {
            this.infoType[typeIndex].typeList = this.infoType[typeIndex].typeList.concat(response.data.Data[resListName])
            // 如果載入更多時，剛好有人新增資料，刪除重複值
            this.infoType[typeIndex].typeList = [...new Set(this.infoType[typeIndex].typeList)]
          }
          // 檢查是否還能載入更多      
          if (this.infoType[typeIndex].typeList.length < 50) {
            this.infoType[typeIndex].mescroll.endSuccess(50, false)
          } else {
            this.infoType[typeIndex].mescroll.endSuccess()
          }
        }
      }).catch((err) => {
        console.log(err)
        this.infoType[typeIndex].typeList = []
        this.infoType[typeIndex].mescroll.endSuccess(50, false)
        this.infoType[typeIndex].mescroll.endUpScroll(false)
      })
    },
    InitSwiperList(){
      const vobj = this
      const Top = vobj.$refs.infoTop.swiper;
      const Pages = vobj.$refs.infoPages.swiper;
      const TypeId = vobj.infoType[0].typeId
      const Selected = vobj.$route.query['tab']
      Top.slides.each(function(index, val){
        var ele = $(this);
        ele.on("click", function() {
          vobj.SlidesToPage(index);
          vobj.whichTypeIndexIsChoose = index
        })
        let nowTypeId = $(val).attr('typeId');
        if(Selected != undefined){
          if(index == Selected){
            vobj.SlidesToPage(index);
          }
        }else{
          if(nowTypeId == TypeId){
            vobj.SlidesToPage(index);
          }
        }
      })
      Pages.on('slideChangeTransitionStart', function(){
        vobj.SlidesToPage(this.activeIndex);
        vobj.whichTypeIndexIsChoose = this.activeIndex
        if (!vobj.infoType[this.activeIndex].typeList) {
          vobj.getList(this.activeIndex)
        }
      })
    },
    //切換頁面
    SlidesToPage(page){
      const Top = this.$refs.infoPages.swiper;
      const Pages = this.$refs.infoPages.swiper
      Pages.slideTo(page, 500);
      $(".swiperTop .swiper-slide").removeClass("selected");
      $(".swiperTop .swiper-slide").eq(page).addClass("selected");
    },
    //檢查權限
    CheckAuthority(){
      if(localStorage.getItem("v3token")=='' || localStorage.getItem("v3token") == null){
        this.Authority= false
      }else{
        this.Authority= true
      }
    },
    closeOfflineHandle(){
      this.closeOffline = true
    },
    showV3Toast(text) {
      clearTimeout(this.toastTimer)
      this.v3Toast.text = text;
      this.v3Toast.show = true;
      this.toastTimer = setTimeout(() => {
        this.v3Toast.show = false;
      }, this.v3Toast.duration);
    },
    // 上拉加載 (註冊)
    getMescrollUp (tabIndex) {
      const vm = this
      return {
        auto: false,
        callback: vm.loadMoreData,
        htmlLoading: '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">載入更多</p>',
        htmlNodata: '<p class="upwarp-nodata">噢不！沒有更多了</p>',
        textInOffset: '載入更多',
        textOutOffset: '',
        textLoading: '載入中...',
      }
    },
    // 下拉更新 (註冊)
    getMescrollDown(tabIndex) {
      const vm = this
      return {
        auto: false,
        callback: vm.refreshAllData,
        textInOffset: '下拉更新',
        textOutOffset: '',
        textLoading: '載入中...'
      }
    },
    // 初始註冊 mescroll 的地方
    mescrollInit(tabIndex, arg) {
      this.infoType[tabIndex].mescroll = arg[0]
      this.infoType[tabIndex].mescroll.tabIndex = tabIndex
    },
    refreshAllData(mescroll) {
      if (this.isOffline) {
        this.showV3Toast('網路狀態異常')
        this.infoType[mescroll.tabIndex].mescroll.endSuccess()
        return
      }
      this.infoType[mescroll.tabIndex].typeList = []
      this.whichTypeIndexIsChoose = mescroll.tabIndex;
      this.$refs.infoPages.swiper.slideTo(mescroll.tabIndex)
      this.infoType[mescroll.tabIndex].mescroll.endSuccess(50, true)
      this.infoType[mescroll.tabIndex].mescroll.showDownScroll();
      this.getList(mescroll.tabIndex, 0)
    },
    loadMoreData() {
      if (this.isOffline) {
        this.showV3Toast('網路狀態異常')
        this.infoType[this.whichTypeIndexIsChoose].mescroll.endErr()
        return
      }
      const alreadyExist = this.infoType[this.whichTypeIndexIsChoose].typeList.length
      const page = Math.ceil(alreadyExist / 50)
      this.getList(this.whichTypeIndexIsChoose, page)
    },
    seeDetail (type, id, index) {
      this.$router.push({
        name: 'newMunicipalInfoDetail',
        params: {
          type: type.toString(),
          id: id,
          idx: index
        },
      })
      this.scrollTop = this.infoType[this.whichTypeIndexIsChoose].mescroll.preScrollY;
    },
    filterDate(date, tab) {
      const splitDate = date.split('/')
      switch(tab) {
        case 1:
          return date.split('T')[0]
        case 2:
        case 3:
          return `${splitDate[2]}/${splitDate[0]}/${splitDate[1]}`
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    const vm = this
    if(vm.isOffline){
      vm.showV3Toast('網路狀態異常')
    }else{
      next()
    }
  }
}
</script>
<style scoped>
.v3Toast {
  z-index: 10;
  position: fixed;
  left: 50%;
  top: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  background: rgba(0, 0, 0, 0.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  color: #fff;
  font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  font-weight: 500;
}
.v3offline {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 44px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 21px;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  color: #fff;
  background: rgba(
    66,
    137,
    167,
    0.9
  ); /* #4289a7 2020/11/19 13:37 BD mean this color */
  -webkit-transition: 0.5s;
  transition: 0.5s;
}
.v3offline > i {
  margin-right: 9px;
  font-size: 19px;
  width: 19px;
  height: 19px;
}
.v3offline div {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.swiper-container {
  padding-top: 1px
}
</style>




// WEBPACK FOOTER //
// src/components/v3/newMunicipal/municipalInfo.vue